import { Link } from "react-router-dom";

export default function TrustSection() {
  return (
    <section className="py-10 md:py-20 bg-gradient-to-br from-background-50 via-primary-50/15 to-accent-50/25">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <p className="text-xs md:text-sm text-primary-600 font-medium mb-2 md:mb-3 uppercase tracking-wider">Confianza local en Málaga</p>
        <h2 className="text-2xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-3 md:mb-4 leading-tight">
          Más de <span className="font-heading italic text-primary-500">diez</span> años reparando persianas en Málaga
        </h2>
        <p className="text-sm md:text-base text-foreground-600 mb-10">
          Presupuesto gratis · Técnicos en plantilla · Sin intermediarios · Factura y seguro
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* 10+ years card */}
          <div className="bg-gradient-to-br from-primary-500 to-primary-600 text-background-50 rounded-2xl p-8 md:p-10 relative overflow-hidden">
            <Link
              to="/sobre-nosotros"
              className="absolute top-5 right-5 w-10 h-10 bg-background-50/20 hover:bg-background-50/30 rounded-full flex items-center justify-center transition-colors cursor-pointer"
            >
              <span className="w-5 h-5 flex items-center justify-center"><i className="ri-arrow-right-up-line text-background-50 text-lg"></i></span>
            </Link>
            <span className="text-6xl md:text-7xl font-bold font-heading">10+</span>
            <p className="text-base md:text-lg mt-4 text-background-50/90">Años de experiencia en Málaga</p>
            <p className="text-sm text-background-50/80">Servicio en 24-48 horas en los 16 barrios</p>
            <p className="text-sm italic mt-6 text-background-50/70 font-heading">Reparar antes que sustituir, nuestro compromiso</p>
          </div>

          {/* 2-year warranty card */}
          <div className="bg-accent-100/40 rounded-2xl p-8 md:p-10 relative overflow-hidden">
            <Link
              to="/servicios/persianas"
              className="absolute top-5 right-5 w-10 h-10 bg-foreground-950/5 hover:bg-foreground-950/10 rounded-full flex items-center justify-center transition-colors cursor-pointer"
            >
              <span className="w-5 h-5 flex items-center justify-center"><i className="ri-arrow-right-up-line text-foreground-600 text-lg"></i></span>
            </Link>
            <span className="text-6xl md:text-7xl font-bold font-heading text-secondary-900">2</span>
            <p className="text-base md:text-lg mt-4 text-secondary-800">Años de garantía en todas</p>
            <p className="text-sm text-secondary-700">nuestras reparaciones e instalaciones</p>
            <p className="text-sm text-secondary-700">Cubriendo piezas y mano de obra</p>
          </div>
        </div>
      </div>
    </section>
  );
}